export class WorkspaceAwsStorageAccessConfiguration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allowedCredentialProfiles",
            "baseName": "allowedCredentialProfiles",
            "type": "Array<WorkspaceStorageAllowedCredentialsProfile>",
            "format": ""
        },
        {
            "name": "allowedPrincipals",
            "baseName": "allowedPrincipals",
            "type": "Array<WorkspaceAllowedPrincipal>",
            "format": ""
        },
        {
            "name": "requirePrincipalTags",
            "baseName": "requirePrincipalTags",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceAwsStorageAccessConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
